<template>
  <div id="app">
    <HeaderView></HeaderView>
    <BreadList></BreadList>
    <router-view v-if="isRouterAlive"></router-view>
    <FooterView></FooterView>
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView";
import FooterView from "@/components/FooterView";
import BreadList from "@/components/BreadList";
export default {
  name: "App",
  components: {
    HeaderView,
    FooterView,
    BreadList,
  },
  data() {
    return {
      isRouterAlive:true
    };
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  }
};
</script>
<style lang="scss">
</style>
